import * as actionTypes from "../Action/ActionTypes";
import * as actionReducer from "./ActionReducer";

const initialState = {
  dialogsFlag: {
    addOrg: false,
    deleteOrg: false,
    addTenant: false,
    deleteTenant: false,
    SelectLocation: false,
  },

  tenantsList: [],

  Organization: {
    error: null,
    request: null,
    response: null,
  },

  Tenants: {
    error: null,
    request: null,
    response: null,
  },

  EditOrg: {
    error: null,
    request: null,
    response: null,
  },

  AddTenant: {
    error: null,
    request: null,
    response: null,
  },

  EditTenant: {
    error: null,
    request: null,
    response: null,
  },

  OrgActivation: {
    error: null,
    request: null,
    response: null,
  },

  TenantActivation: {
    error: null,
    request: null,
    response: null,
  },

  OrganizationUser: {
    error: null,
    request: null,
    response: null,
  },

  TenantUser: {
    error: null,
    request: null,
    response: null,
  },

  Tenant: {
    error: null,
    request: null,
    response: null,
  },

  DeleteTenant: {
    error: null,
    request: null,
    response: null,
  },

  UpdateTenantUser: {
    error: null,
    request: null,
    response: null,
  },

  UpdateOrgUser: {
    error: null,
    request: null,
    response: null,
  },

  TenantPassword: {
    error: null,
    request: null,
    response: null,
  },

  OtherUserToken: {
    error: null,
    request: null,
    response: null,
  },

  OrgUsage: {
    error: null,
    request: null,
    response: null,
    tenantsId: [],
    tenantsList: [],
  },

  DownloadUsage: {
    error: null,
    request: null,
    response: null,
  },

  UpdatePOC: {
    error: null,
    request: null,
    response: null,
  },

  OrgPOC: {
    error: null,
    request: null,
    response: null,
  },

  AddOrgPOC: {
    error: null,
    request: null,
    response: null,
  },

  RemoveOrgPOC: {
    error: null,
    request: null,
    response: null,
  },

  DeliveryReport: {
    error: null,
    request: null,
    response: null,
  },

  ComparePolygon: {
    error: null,
    request: null,
    response: null,
  },


   DeliveryCoordinatesReport: {
    error: null,
    request: null,
    response: null,
  },

    token: {
    error: null,
    request: null,
    response: null,
  },

    tokenForOrganization: {
    error: null,
    request: null,
    response: null,
  },
};

const OrgManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ORG_CHANGE_SHOW_DIALOGS:
      return actionReducer.Dialogs(state, action);

    case actionTypes.ORG_CLEAR_STATE:
      return actionReducer.clearState(state, action, initialState);

    case actionTypes.ORG_GET_ALL_TENANTS:
      return actionReducer.getAllTenants(state, action);
    case actionTypes.ORG_GET_ALL_TENANTS_SUCCESS:
      return actionReducer.getAllTenantsSuccess(state, action);
    case actionTypes.ORG_GET_ALL_TENANTS_FAIL:
      return actionReducer.getAllTenantsFail(state, action);

    case actionTypes.COMPARE_POLYGONS_CHART:
      return actionReducer.comparePolygons(state, action);
    case actionTypes.COMPARE_POLYGONS_CHART_SUCCESS:
      return actionReducer.comparePolygonsSuccess(state, action);
    case actionTypes.COMPARE_POLYGONS_CHART_FAIL:
      return actionReducer.comparePolygonsFail(state, action);

    case actionTypes.ORG_EDIT_ORGANIZATION:
      return actionReducer.editOrg(state, action);
    case actionTypes.ORG_EDIT_ORGANIZATION_SUCCESS:
      return actionReducer.editOrgSuccess(state, action);
    case actionTypes.ORG_EDIT_ORGANIZATION_FAIL:
      return actionReducer.editOrgFail(state, action);

    case actionTypes.ORG_ADD_TENANT:
      return actionReducer.addTenant(state, action);
    case actionTypes.ORG_ADD_TENANT_SUCCESS:
      return actionReducer.addTenantSuccess(state, action);
    case actionTypes.ORG_ADD_TENANT_FAIL:
      return actionReducer.addTenantFail(state, action);

    case actionTypes.ORG_EDIT_TENANT:
      return actionReducer.editTenant(state, action);
    case actionTypes.ORG_EDIT_TENANT_SUCCESS:
      return actionReducer.editTenantSuccess(state, action);
    case actionTypes.ORG_EDIT_TENANT_FAIL:
      return actionReducer.editTenantFail(state, action);

    case actionTypes.ORG_GET_ORGANIZATION_BY_ID:
      return actionReducer.getOrgById(state, action);
    case actionTypes.ORG_GET_ORGANIZATION_BY_ID_SUCCESS:
      return actionReducer.getOrgByIdSuccess(state, action);
    case actionTypes.ORG_GET_ORGANIZATION_BY_ID_FAIL:
      return actionReducer.getOrgByIdFail(state, action);

    case actionTypes.ORG_CHANGE_TENANT_ACTIVATION:
      return actionReducer.changeTenantActivation(state, action);
    case actionTypes.ORG_CHANGE_TENANT_ACTIVATION_SUCCESS:
      return actionReducer.changeTenantActivationSuccess(state, action);
    case actionTypes.ORG_CHANGE_TENANT_ACTIVATION_FAIL:
      return actionReducer.changeTenantActivationFail(state, action);

    case actionTypes.ORG_DELETE_TENANT:
      return actionReducer.deleteTenant(state, action);
    case actionTypes.ORG_DELETE_TENANT_SUCCESS:
      return actionReducer.deleteTenantSuccess(state, action);
    case actionTypes.ORG_DELETE_TENANT_FAIL:
      return actionReducer.deleteTenantFail(state, action);

    case actionTypes.ORG_GET_TENANT_BY_ID:
      return actionReducer.getTenantById(state, action);
    case actionTypes.ORG_GET_TENANT_BY_ID_SUCCESS:
      return actionReducer.getTenantByIdSuccess(state, action);
    case actionTypes.ORG_GET_TENANT_BY_ID_FAIL:
      return actionReducer.getTenantByIdFail(state, action);

    case actionTypes.ORG_GET_ORGANIZATION_USER:
      return actionReducer.getOrganizationUser(state, action);
    case actionTypes.ORG_GET_ORGANIZATION_USER_SUCCESS:
      return actionReducer.getOrganizationUserSuccess(state, action);
    case actionTypes.ORG_GET_ORGANIZATION_USER_FAIL:
      return actionReducer.getOrganizationUserFail(state, action);

    case actionTypes.ORG_GET_TENANT_USER:
      return actionReducer.getTenantUser(state, action);
    case actionTypes.ORG_GET_TENANT_USER_SUCCESS:
      return actionReducer.getTenantUserSuccess(state, action);
    case actionTypes.ORG_GET_TENANT_USER_FAIL:
      return actionReducer.getTenantUserFail(state, action);

    case actionTypes.ORG_UPDATE_ORGANIZATION_USER:
      return actionReducer.updateOrgUser(state, action);
    case actionTypes.ORG_UPDATE_ORGANIZATION_USER_SUCCESS:
      return actionReducer.updateOrgUserSuccess(state, action);
    case actionTypes.ORG_UPDATE_ORGANIZATION_USER_FAIL:
      return actionReducer.updateOrgUserFail(state, action);

    case actionTypes.ORG_UPDATE_TENANT_USER:
      return actionReducer.updateTenantUser(state, action);
    case actionTypes.ORG_UPDATE_TENANT_USER_SUCCESS:
      return actionReducer.updateTenantUserSuccess(state, action);
    case actionTypes.ORG_UPDATE_TENANT_USER_FAIL:
      return actionReducer.updateTenantUserFail(state, action);

    case actionTypes.ORG_CHANGE_TENANT_PASSWORD:
      return actionReducer.changeTenantPassword(state, action);
    case actionTypes.ORG_CHANGE_TENANT_PASSWORD_SUCCESS:
      return actionReducer.changeTenantPasswordSuccess(state, action);
    case actionTypes.ORG_CHANGE_TENANT_PASSWORD_FAIL:
      return actionReducer.changeTenantPasswordFail(state, action);

    case actionTypes.ORG_GET_USER_TOKEN:
      return actionReducer.getUserToken(state, action);
    case actionTypes.ORG_GET_USER_TOKEN_SUCCESS:
      return actionReducer.getUserTokenSuccess(state, action);
    case actionTypes.ORG_GET_USER_TOKEN_FAIL:
      return actionReducer.getUserTokenFail(state, action);

    case actionTypes.ORG_MNG_GET_USER_TOKEN_BY_TENANT_ID:
      return actionReducer.getUserToken(state, action);

    case actionTypes.ORG_GET_ORGANIZATION_USAGE:
      return actionReducer.getOrganizationUsage(state, action);
    case actionTypes.ORG_GET_ORGANIZATION_USAGE_SUCCESS:
      return actionReducer.getOrganizationUsageSuccess(state, action);
    case actionTypes.ORG_GET_ORGANIZATION_USAGE_FAIL:
      return actionReducer.getOrganizationUsageFail(state, action);

    case actionTypes.ORG_DOWNLOAD_USAGE:
      return actionReducer.downloadUsage(state, action);
    case actionTypes.ORG_DOWNLOAD_USAGE_SUCCESS:
      return actionReducer.downloadUsageSuccess(state, action);
    case actionTypes.ORG_DOWNLOAD_USAGE_FAIL:
      return actionReducer.downloadUsageFail(state, action);

    case actionTypes.ORG_GET_ORG_POC:
      return actionReducer.getOrgPOC(state, action);
    case actionTypes.ORG_GET_ORG_POC_SUCCESS:
      return actionReducer.getOrgPOCSuccess(state, action);
    case actionTypes.ORG_GET_ORG_POC_FAIL:
      return actionReducer.getOrgPOCFail(state, action);

    case actionTypes.ORG_UPDATE_ORG_POC:
      return actionReducer.updateOrgPOC(state, action);
    case actionTypes.ORG_UPDATE_ORG_POC_SUCCESS:
      return actionReducer.updateOrgPOCSuccess(state, action);
    case actionTypes.ORG_UPDATE_ORG_POC_FAIL:
      return actionReducer.updateOrgPOCFail(state, action);

    case actionTypes.ORG_ADD_ORG_POC:
      return actionReducer.addOrgPOC(state, action);
    case actionTypes.ORG_ADD_ORG_POC_SUCCESS:
      return actionReducer.addOrgPOCSuccess(state, action);
    case actionTypes.ORG_ADD_ORG_POC_FAIL:
      return actionReducer.addOrgPOCFail(state, action);

    case actionTypes.ORG_REMOVE_ORG_POC:
      return actionReducer.removeOrgPOC(state, action);
    case actionTypes.ORG_REMOVE_ORG_POC_SUCCESS:
      return actionReducer.removeOrgPOCSuccess(state, action);
    case actionTypes.ORG_REMOVE_ORG_POC_FAIL:
      return actionReducer.removeOrgPOCFail(state, action);

    case actionTypes.DELIVERY_REPORT:
      return actionReducer.deliveryReport(state, action);
    case actionTypes.DELIVERY_REPORT_SUCCESS:
      return actionReducer.deliveryReportSuccess(state, action);
    case actionTypes.DELIVERY_REPORT_FAIL:
      return actionReducer.deliveryReportFail(state, action);

      case actionTypes.DELIVERY_COORDINATE_REPORT:
          return actionReducer.deliveryCoordinatesReport(state, action);
      case actionTypes.DELIVERY_COORDINATE_REPORT_SUCCESS:
          return actionReducer.deliveryCoordinatesReportSuccess(state, action);
      case actionTypes.DELIVERY_COORDINATE_REPORT_FAIL:
          return actionReducer.deliveryCoordinatesReportFail(state, action);

      case actionTypes.GET_TOKEN:
          return actionReducer.getToken(state, action);
      case actionTypes.GET_TOKEN_SUCCESS:
          return actionReducer.getTokenSuccess(state, action);
      case actionTypes.GET_TOKEN_FAIL:
          return actionReducer.getTokenFail(state, action);

      case actionTypes.GET_TOKEN_FOR_ORGANIZATION:
          return actionReducer.getTokenForOrganization(state, action);
      case actionTypes.GET_TOKEN_FOR_ORGANIZATION_SUCCESS:
          return actionReducer.getTokenForOrganizationSuccess(state, action);
      case actionTypes.GET_TOKEN_FOR_ORGANIZATION_FAIL:
          return actionReducer.getTokenForOrganizationFail(state, action);

    default:
      return state;
  }
};

export { OrgManagerReducer };
